<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a(slot="trigger") Document Requirements
      h2 Requirement {{entity_type}} {{entity_id}}
      .row
        .columns
          label Document type
            SelectizeDocumentType(@optionSelected="documentTypeSelected")
        .columns
          label Document group
            input(type="text", v-model="body.document_group")
      .row.columns.text-center
        ActionButton(:action="save") Add requirement
      hr
      h2 Document Requirements
      loading-spinner(v-if="requirements.length === 0" )
      document-requirement(v-for="item in requirements", :item="item" v-if="requirements.length", type="listing", @itemUpdated="loadRequirements")
      //requirement-list(entity_type="VehicleCategory", :entity_id="this.entity_id", ref="requirementListing" )
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import SelectizeDocumentType from '../lists/selectize/SelectizeDocumentType'
import SelectizeCategory from '../lists/selectize/SelectizeCategory'
import SelectizePlan from '../lists/selectize/SelectizePlan'
import SelectizeClientType from "../lists/selectize/SelectizeClientType";
import ActionButton from "../ActionButton";
import RequirementList from "../../../../pages/backoffice/DocumentRequirementList";
import DocumentRequirement from "../../../backoffice/DocumentRequirement";
import LoadingSpinner from "../../LoadingSpinner";

export default {
  name: 'RequirementModal',
  components: {
    LoadingSpinner,
    DocumentRequirement,
    RequirementList,
    ActionButton, SelectizeClientType, SelectizePlan, SelectizeCategory, SelectizeDocumentType, ModalReveal
  },
  data() {
    return {
      body: {
        "entity_type": this.entity_type,
        "entity_id": this.entity_id,
        "document_type_id": null,
        "document_group": null
      },
      requirements: []
    }
  },
  created() {
    this.hide = !this.hide
    this.loadRequirements()
  },
  methods: {
    documentTypeSelected(obj) {
      //this.body.document_types.push(obj.id)
      this.body.document_type_id = obj.id
    },
    loadRequirements() {
      this.requirements = []
      KeplerBackofficeSdk.documentRequirements.list().all((data) => {
        this.requirements = data.filter((item) => {
          return this.entity_id === item.entity.id && this.entity_type === item.entity_class.replace(/App\\Models\\/, '')
        })
      })
    },
    save() {
      return KeplerBackofficeSdk.documentRequirements.make(this.body, () => {
        this.$emit('itemUpdated')
        this.loadRequirements()
      })
    }
  },
  props: ['entity_id', 'entity_type'],
  computed: {
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// RequirementModal.vue?2c6268fa